import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {fadeInAnimation} from '../../animations/fade-in.animation';

@Component({
  selector: 'app-modal-expert-not-available',
  templateUrl: './modal-expert-not-available.component.html',
  styleUrls: ['./modal-expert-not-available.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalExpertNotAvailableComponent implements OnInit {

  @Input() showModalExpertNotAvailable: boolean;
  @Input() clinicId: string;
  @Input() expertId: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se cierra el modal.
   */
  onEmitCloseModal(): void {
    this.closeModal.emit(true);
  }

  /**
   * Envía al perfil del experto
   */
  onGotoProfile(): void {
    this.router.navigate(['clinic', this.clinicId, 'profile', 'expert', 'me']);
  }
}
